import { LangCode } from '@educraft/base';

export function calculateEaster(year: number): Date {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month, day);
}

export function getHolidays(year: number, langCode: LangCode): Date[] {
  if (langCode !== 'cs') {
    return [];
  }

  const holidays: Date[] = [
    new Date(year, 0, 1), // New Year
    new Date(year, 4, 1), // Labour Day
    new Date(year, 4, 8), // Liberation Day
    new Date(year, 6, 5), // Saints Cyril and Methodius
    new Date(year, 6, 6), // Jan Hus Day
    new Date(year, 8, 28), // Czech Statehood Day
    new Date(year, 9, 28), // Czechoslovak Independence Day
    new Date(year, 10, 17), // Freedom and Democracy Day
    new Date(year, 11, 24), // Christmas Eve
    new Date(year, 11, 25), // Christmas Day
    new Date(year, 11, 26), // St. Stephen's Day
  ];

  const easter = calculateEaster(year);
  holidays.push(easter);
  holidays.push(new Date(easter.getTime() + 86400000));

  return holidays;
}
